
import React from 'react';
import { SortOption } from '@/components/reader-home/types';

interface CommentSorterProps {
  sortOption: SortOption;
  onSortChange: (option: SortOption) => void;
}

const CommentSorter: React.FC<CommentSorterProps> = ({
  sortOption,
  onSortChange
}) => {
  return (
    <select
      className="bg-background border border-input rounded-md text-sm px-2 py-1"
      value={sortOption}
      onChange={(e) => onSortChange(e.target.value as SortOption)}
    >
      <option value="newest">Newest</option>
      <option value="most-liked">Most Liked</option>
      <option value="highlighted">Journalist Highlighted</option>
    </select>
  );
};

export default CommentSorter;
